import { render, staticRenderFns } from "./scroll-ruler.vue?vue&type=template&id=32c9ef3c&scoped=true&"
import script from "./scroll-ruler.vue?vue&type=script&lang=ts&"
export * from "./scroll-ruler.vue?vue&type=script&lang=ts&"
import style0 from "./scroll-ruler.vue?vue&type=style&index=0&id=32c9ef3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c9ef3c",
  null
  
)

export default component.exports